import React, { useState } from 'react';
import type { TemplateEdgeT, TemplateNodeT } from '../../../../labelling-v2/types/skeleton-template-builder.type';
import { CanvasEdge } from './canvas-edge';
type CanvasEdgesPropsT = {
  edges: TemplateEdgeT[];
  nodeMap: Map<string, TemplateNodeT>;
  strokeColor: string;
};
export function CanvasEdges({
  edges,
  nodeMap,
  strokeColor
}: CanvasEdgesPropsT) {
  const [hoveredEdgeKey, setHoveredEdgeKey] = useState<string | null>(null);
  return <>
      {edges.map(edge => {
      const sourceNode = nodeMap.get(edge.sourceNodeId);
      const targetNode = nodeMap.get(edge.targetNodeId);
      if (!sourceNode || !targetNode) return null;
      const edgeKey = `${edge.sourceNodeId}-${edge.targetNodeId}`;
      return <CanvasEdge key={edgeKey} fromPosition={[sourceNode.x, sourceNode.y]} toPosition={[targetNode.x, targetNode.y]} strokeColor={strokeColor} highlighted={hoveredEdgeKey === edgeKey} onHover={hovered => setHoveredEdgeKey(hovered ? edgeKey : null)} />;
    })}
    </>;
}